import { dehydrate } from '@tanstack/react-query';
import type { GetServerSideProps } from 'next';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';

import { BannerSlot } from '@/core/lib/ads/ads.context';
import Query from '@/core/lib/new-architecture/query';
import makeQueryClient from '@/core/lib/query/queryClient';
import base from '@/core/lib/translation/base';
import PublicProfile from '@/core/pages/profile/PublicProfile';
import { usersPublicProfilResultSchema } from '@/core/types/profile';
import DetailsLayout from '@/next/layouts/DetailsLayout';

export const getServerSideProps: GetServerSideProps = async context => {
  const queryClient = makeQueryClient();
  const { params } = context;
  const { uuid } = usersPublicProfilResultSchema.cast(params, { stripUnknown: true, assert: false });

  await Query.donations.useDonations.prefetch?.({ queryClient, giver: uuid });
  await Query.categories.useCategories.prefetch?.({ queryClient });
  await Query.user.usePublicProfile.prefetch?.({ queryClient, uuid });
  const dehydratedState = dehydrate(queryClient);
  return {
    props: {
      ...(await serverSideTranslations('fr', [...base, 'profile.profile-public', 'conversation.chat'])),
      path: `/profil/public/${context.query.uuid}`,
      dehydratedState,
    },
  };
};

PublicProfile.getLayouts = page => {
  const adUnit = '/22963265510,23187251655/23187251655/od.donnons.org/recherche';
  const dataConfig = {
    adUnit,
  };
  return (
    <DetailsLayout adSlot={BannerSlot.DONNONS_LIST_SIDE}>
      <Head>
        <script dangerouslySetInnerHTML={{ __html: 'var optidigitalQueue = optidigitalQueue || {}; optidigitalQueue.cmd = optidigitalQueue.cmd || [];' }}></script>
        <link rel="preload" href="https://securepubads.g.doubleclick.net/tag/js/gpt.js" as="script" type="text/javascript" />
        <script type="module" id="optidigital-ad-init" async src="//scripts.opti-digital.com/modules/?site=donnons" data-config={JSON.stringify(dataConfig)} key={adUnit}></script>
      </Head>
      {page}
    </DetailsLayout>
  );
};

export default PublicProfile;
